import { render } from "./DepositOptionsModal.vue?vue&type=template&id=70512ad6&scoped=true"
const script = {}

import "./DepositOptionsModal.vue?vue&type=style&index=0&id=70512ad6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70512ad6"]])

export default __exports__